import PhotoDetailsSection from '../src/PhotoDetailsSection';
export default PhotoDetailsSection;
